import { Timestamp } from "firebase/firestore";
import { Company } from "../interfaces/entities/company";

export const defaultCompany = (userId: string): Company => ({
    id: "",
    name: "",
    email: '',
    address: "",
    image: "",
    contact: "",
    config: {
        phoneMandatoryForReview: false
    },

    createdAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date())
})